import React from "react";
import fetch from "unfetch";
import FeatherIcon from "feather-icons-react";
import { Alert, Button, Col } from "reactstrap";
import Form from "../Form";
import { pipe, withState, withHandlers } from "../../libs/rehook";

const phoneRegex = /^(([0+]\d{2,3}-)?(0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/;
const mobileRegex = new RegExp("^((13[0-9])|(14[5,6,7,9])|(15[^4])|(16[5,6])|(17[0-9])|(18[0-9])|(19[1,8,9]))\\d{8}$");
const emailRegex = new RegExp("^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?.)+[a-z]{2,}$");

const valid = (name, value) => {
  let flag = false;
  if (name === "name" || name === "company") {
    flag = value && value.length > 1;
  } else if (name === "email") {
    flag = emailRegex.test(value);
  } else if (name === "phone") {
    flag = mobileRegex.test(value) || phoneRegex.test(value);
  } else if (name === "services") {
    flag = value && value.length > 0;
  } else if (name === "scale") {
    flag = value && value.length > 0;
  }
  return flag;
};

const enhance = pipe(
  withState("success", "setSuccess"),
  withState("error", "setError"),
  withState("localValue", "setLocalValue", {}),
  withState("validate", "setValidate", {
    name: false,
    company: false,
    phone: false,
  }),
  withState("invalidate", "setInvalidate", {
    name: false,
    company: false,
    phone: false,
  }),
  withHandlers(() => ({
    onChange: ({ localValue, setLocalValue, validate, setValidate, setInvalidate, invalidate, setError }) => (name, value) => {
      setLocalValue({ ...localValue, [name]: value });
      const flag = valid(name, value);
      setValidate({ ...validate, [name]: flag });
      if (flag) {
        setInvalidate({ ...invalidate, [name]: false });
      }
      setError("");
    },
    handleSubmit: ({ localValue, invalidate, setInvalidate, setSuccess, setError }) => () => {
      invalidate.name = !valid("name", localValue.name);
      invalidate.company = !valid("company", localValue.company);
      invalidate.phone = !valid("phone", localValue.phone);
      setError("");
      if (invalidate.name || invalidate.company || invalidate.phone) {
        setInvalidate({ ...invalidate });
      } else {
        fetch("/reservation", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(localValue),
        })
          .then(resp => {
            if (!resp.ok) {
              if (resp.status === 429) {
                setError("您提交的太频繁了！");
              } else {
                setError(resp.statusText);
              }
            } else {
              resp.json().then(result => {
                console.log(result);
                setSuccess(true);
              });
            }
          })
          .catch(err => {
            console.log("err", err);
          });
      }
    },
  }))
);

function ReservationForm(props) {
  const { handleSubmit, onChange, localValue, validate, invalidate, success, error, omits = [] } = props;
  if (success) {
    return (
      <div className="d-flex pt-3 pb-3">
        <div>
          <i>
            <FeatherIcon icon="check-circle" color="green" size="64" className="fea icons" />
          </i>
        </div>
        <div className="ml-3">
          <h5>提交成功，谢谢！</h5>
          <h6>我们会第一时间联系您。</h6>
        </div>
      </div>
    );
  }

  const form = [
    {
      label: "姓名",
      prop: "name",
      icon: "user",
      type: "text",
      placeholder: "您的名字",
      required: true,
      error: "请输入您的名字",
      component: "input",
    },
    {
      label: "企业名称",
      prop: "company",
      icon: "home",
      type: "text",
      placeholder: "您的公司全称",
      required: true,
      error: "请输入公司名称",
      component: "input",
    },
    // {
    //   label: '邮箱',
    //   prop: 'email',
    //   icon: 'mail',
    //   type: 'email',
    //   placeholder: '您的电子邮箱',
    //   required: true,
    //   error: '电子邮箱无效',
    //   component: 'input',
    // },
    {
      label: "电话号码",
      prop: "phone",
      icon: "phone",
      type: "tel",
      placeholder: "您的电话号码",
      required: true,
      error: "电话号码无效",
      component: "input",
    },
    {
      label: "您关注的服务",
      prop: "services",
      icon: "phone",
      type: "tel",
      required: false,
      error: "",
      component: "select",
      multi: true,
      options: [
        { text: "人员招聘", value: "人员招聘" },
        { text: "员工培训", value: "员工培训" },
        { text: "组织发展", value: "组织发展" },
        { text: "绩效管理", value: "绩效管理" },
        { text: "人事流程管理", value: "人事流程管理" },
      ],
    },
    {
      label: "您的企业规模",
      prop: "scale",
      required: false,
      error: "",
      component: "select",
      multi: false,
      options: [
        { text: "100人以下", value: "100人以下" },
        { text: "100-1000人", value: "100-1000人" },
        { text: "1000-5000人", value: "1000-5000人" },
        { text: "5000人以上", value: "5000人以上" },
      ],
    },
  ];

  const omitForm = form.filter(f => !omits.includes(f.prop));

  return (
    <Form form={omitForm} localValue={localValue} validate={validate} invalidate={invalidate} onChange={onChange}>
      <Col lg="12" className="mt-2 mb-0">
        <Button onClick={handleSubmit} color="primary" block>
          预约演示
        </Button>
      </Col>
      {error && (
        <Alert className="mt-2 ml-3" color="danger">
          {error}
        </Alert>
      )}
    </Form>
  );
}

export default pipe(enhance, ReservationForm);
